import { GuessFeed } from "../../shared/ui";

// ── Drawing Host Screen ───────────────────────────────────────────────────────
// Props:
//   drawer   : string        — name of the player who is drawing
//   hint     : string        — word hint shown to watchers
//   drawData : string | null — base64 image data URL from drawing_update
//   guesses  : { player, guess, correct }[]
//   revealed : string | null — actual word, shown after round ends
//   players  : object[]
//   onEnd    : () => void    — emit end_drawing_turn
//   tv       : bool

export default function DrawingHost({ drawer, hint, drawData, guesses, revealed, players, onEnd, tv }) {
  return (
    <div className="w-full">
      {/* Header: who is drawing + hint */}
      <div className="text-center mb-3">
        <span className="font-body text-[#aaa]" style={{ fontSize: tv ? "1.3rem" : "0.85rem" }}>Рисует: </span>
        <span className="font-heading" style={{ fontSize: tv ? "2.5rem" : "1.4rem", color: "#FF00FF", textShadow: "2px 2px 0 #000" }}>
          {drawer}
        </span>
        <div className="font-heading" style={{ fontSize: tv ? "1.6rem" : "0.95rem", color: revealed ? "#3DFF3D" : "#FFE000", marginTop: "0.2rem" }}>
          {revealed ? `🎉 Слово было: ${revealed}` : `💡 ${hint}`}
        </div>
      </div>

      {/* Main layout: canvas + sidebar */}
      <div className="flex gap-4" style={{ alignItems: "flex-start" }}>
        {/* Canvas */}
        <div className="flex-1 flex flex-col min-w-0">
          <div style={{
            background: "#0a001e", border: "3px solid #333", borderRadius: "1rem",
            boxShadow: "5px 5px 0 #000", width: "100%",
            height: tv ? "calc(100vh - 220px)" : "calc(100vh - 195px)",
            display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden",
          }}>
            {drawData
              ? <img src={drawData} alt="" style={{ width: "100%", height: "100%", objectFit: "contain", display: "block" }} data-testid="drawing-canvas" />
              : <div className="font-heading text-[#333]" style={{ fontSize: tv ? "1.5rem" : "1rem" }}>Ожидание рисунка...</div>
            }
          </div>

          {revealed && (
            <div className="text-center mt-3 animate-bounce-in font-heading"
              style={{ fontSize: tv ? "2.5rem" : "1.5rem", color: "#3DFF3D", textShadow: "2px 2px 0 #000" }}>
              🎉 Это было: {revealed}
            </div>
          )}

          <div className="text-center mt-3">
            <button
              onClick={onEnd}
              data-testid="end-turn-btn"
              className="btn-cartoon btn-error"
              style={{ fontSize: tv ? "1.3rem" : "0.9rem", padding: tv ? "0.8rem 2.25rem" : "0.5rem 1.5rem" }}
            >
              ⏭️ Завершить раунд
            </button>
          </div>
        </div>

        {/* Guess feed */}
        <div style={{ width: tv ? "280px" : "200px", flexShrink: 0 }}>
          <GuessFeed guesses={guesses} tv={tv} />
        </div>
      </div>
    </div>
  );
}